const voronoidata = [
    {
        "id": 0,
        "x": 68.58339630699268,
        "y": 28.17481746814503
    },
    {
        "id": 1,
        "x": 13.685628992065224,
        "y": 15.753129286607791
    },
    {
        "id": 2,
        "x": 90.03032358027343,
        "y": 62.018004848099515
    },
    {
        "id": 3,
        "x": 63.07694733922964,
        "y": 39.96711196064262
    },
    {
        "id": 4,
        "x": 91.93214385050426,
        "y": 23.96696434930532
    },
    {
        "id": 5,
        "x": 16.592609717930728,
        "y": 62.596174661269124
    },
    {
        "id": 6,
        "x": 42.82210952851977,
        "y": 93.08731723234598
    },
    {
        "id": 7,
        "x": 54.31026261555181,
        "y": 61.69478859320287
    },
    {
        "id": 8,
        "x": 24.24924564174582,
        "y": 46.224592147036915
    },
    {
        "id": 9,
        "x": 36.20492317298123,
        "y": 42.20012756753589
    },
    {
        "id": 10,
        "x": 48.90082243522929,
        "y": 33.4803493959527
    },
    {
        "id": 11,
        "x": 61.60777458814772,
        "y": 30.95250759497985
    },
    {
        "id": 12,
        "x": 5.844132084034892,
        "y": 59.436570893060825
    },
    {
        "id": 13,
        "x": 52.71128491418588,
        "y": 78.37370440728728
    },
    {
        "id": 14,
        "x": 68.73286821187415,
        "y": 12.066822950526369
    },
    {
        "id": 15,
        "x": 49.88667735110121,
        "y": 54.01265523763359
    },
    {
        "id": 16,
        "x": 18.521116422474737,
        "y": 42.8691838203416
    },
    {
        "id": 17,
        "x": 67.58279725116732,
        "y": 71.1803014632841
    },
    {
        "id": 18,
        "x": 64.10033400815249,
        "y": 16.932776266442918
    },
    {
        "id": 19,
        "x": 61.190105410799234,
        "y": 6.742377893244189
    },
    {
        "id": 20,
        "x": 24.01914226835158,
        "y": 25.573151432042263
    },
    {
        "id": 21,
        "x": 61.03108973326983,
        "y": 11.359378712744284
    },
    {
        "id": 22,
        "x": 6.192118625676657,
        "y": 15.316763053781957
    },
    {
        "id": 23,
        "x": 37.574986036429145,
        "y": 73.71563891406265
    },
    {
        "id": 24,
        "x": 93.68232727659588,
        "y": 87.19815669463102
    },
    {
        "id": 25,
        "x": 79.55222107971649,
        "y": 53.663809503711704
    },
    {
        "id": 26,
        "x": 40.387358033724574,
        "y": 71.14255838584202
    },
    {
        "id": 27,
        "x": 75.81223339940968,
        "y": 97.57674400469634
    },
    {
        "id": 28,
        "x": 46.93072158755911,
        "y": 15.26939454376064
    },
    {
        "id": 29,
        "x": 19.774155955639472,
        "y": 21.43327162326265
    },
    {
        "id": 30,
        "x": 65.58904217852155,
        "y": 63.11388242265097
    },
    {
        "id": 31,
        "x": 40.30733561774933,
        "y": 19.56554598502438
    },
    {
        "id": 32,
        "x": 12.218216550325533,
        "y": 25.336318349095443
    },
    {
        "id": 33,
        "x": 26.32101909160671,
        "y": 73.7859099800533
    },
    {
        "id": 34,
        "x": 34.16459155042728,
        "y": 0.5192389141385867
    },
    {
        "id": 35,
        "x": 30.900050384083233,
        "y": 6.006649191523872
    },
    {
        "id": 36,
        "x": 41.58580499054156,
        "y": 5.066852733857674
    },
    {
        "id": 37,
        "x": 13.400688989217201,
        "y": 9.695842414755429
    },
    {
        "id": 38,
        "x": 7.518674882055598,
        "y": 11.917174860579305
    },
    {
        "id": 39,
        "x": 88.68180432982446,
        "y": 53.888135610183866
    },
    {
        "id": 40,
        "x": 79.29784813645082,
        "y": 6.9460669176907075
    },
    {
        "id": 41,
        "x": 33.57467126254334,
        "y": 60.93655674559388
    },
    {
        "id": 42,
        "x": 97.16677920428218,
        "y": 67.4950457894552
    },
    {
        "id": 43,
        "x": 13.389127989680837,
        "y": 35.701237149318075
    },
    {
        "id": 44,
        "x": 53.59118356207835,
        "y": 24.44324506888311
    },
    {
        "id": 45,
        "x": 43.2120543550901,
        "y": 33.53328731975269
    },
    {
        "id": 46,
        "x": 45.16271692024858,
        "y": 53.03452766985464
    },
    {
        "id": 47,
        "x": 53.943926014773865,
        "y": 22.452070780527645
    },
    {
        "id": 48,
        "x": 38.93556375079934,
        "y": 37.38899256014938
    },
    {
        "id": 49,
        "x": 83.67091315612952,
        "y": 31.47754487882437
    },
    {
        "id": 50,
        "x": 64.12799519259904,
        "y": 19.188496732537907
    },
    {
        "id": 51,
        "x": 41.76666735907774,
        "y": 1.6368791351845546
    },
    {
        "id": 52,
        "x": 72.51369764529265,
        "y": 92.89099352308293
    },
    {
        "id": 53,
        "x": 28.751386606962527,
        "y": 72.90331269435953
    },
    {
        "id": 54,
        "x": 99.11232062173785,
        "y": 36.305261958214615
    },
    {
        "id": 55,
        "x": 64.42078378201654,
        "y": 50.46386091058317
    },
    {
        "id": 56,
        "x": 58.49190580054493,
        "y": 94.13305392549502
    },
    {
        "id": 57,
        "x": 69.10444300996488,
        "y": 92.18859281751797
    },
    {
        "id": 58,
        "x": 70.40299069260342,
        "y": 80.07103897408396
    },
    {
        "id": 59,
        "x": 50.29752217284435,
        "y": 29.14273769774447
    },
    {
        "id": 60,
        "x": 78.28925858262093,
        "y": 13.445289461124332
    },
    {
        "id": 61,
        "x": 2.473353423691238,
        "y": 65.40092841357499
    },
    {
        "id": 62,
        "x": 55.330278566697324,
        "y": 88.69380698418861
    },
    {
        "id": 63,
        "x": 89.29175782197353,
        "y": 6.069958585863855
    },
    {
        "id": 64,
        "x": 83.38678173678669,
        "y": 32.735854818013046
    },
    {
        "id": 65,
        "x": 69.21391745669487,
        "y": 69.35855538821339
    },
    {
        "id": 66,
        "x": 28.32347490999052,
        "y": 54.89149640944524
    },
    {
        "id": 67,
        "x": 63.889150672483595,
        "y": 91.30824537497091
    },
    {
        "id": 68,
        "x": 43.831672985835766,
        "y": 42.17865403920538
    },
    {
        "id": 69,
        "x": 75.81498445245234,
        "y": 91.51079969760194
    },
    {
        "id": 70,
        "x": 94.18378888199368,
        "y": 18.132557962163375
    },
    {
        "id": 71,
        "x": 48.20493031600756,
        "y": 46.47528100593943
    },
    {
        "id": 72,
        "x": 74.43796038027182,
        "y": 96.3495283770323
    },
    {
        "id": 73,
        "x": 40.938963037831,
        "y": 28.07975828335758
    },
    {
        "id": 74,
        "x": 98.05909191046413,
        "y": 13.871259959828851
    },
    {
        "id": 75,
        "x": 23.503528751009426,
        "y": 39.847069684002065
    },
    {
        "id": 76,
        "x": 11.166613695302718,
        "y": 82.10316365227368
    },
    {
        "id": 77,
        "x": 98.43051681565169,
        "y": 72.31718976792259
    },
    {
        "id": 78,
        "x": 77.28635701367139,
        "y": 83.7294896430444
    },
    {
        "id": 79,
        "x": 48.045997763611204,
        "y": 99.17488476577276
    },
    {
        "id": 80,
        "x": 25.231239551047423,
        "y": 66.94477899372633
    },
    {
        "id": 81,
        "x": 55.90218775525864,
        "y": 20.665598689011833
    },
    {
        "id": 82,
        "x": 54.69715855969031,
        "y": 53.23920476579962
    },
    {
        "id": 83,
        "x": 36.688236595465696,
        "y": 44.453819301989014
    },
    {
        "id": 84,
        "x": 84.93118236313542,
        "y": 0.6768186159928025
    },
    {
        "id": 85,
        "x": 87.57374551638053,
        "y": 9.316992309015992
    },
    {
        "id": 86,
        "x": 72.59049779918097,
        "y": 42.06983771867372
    },
    {
        "id": 87,
        "x": 74.63709625668065,
        "y": 71.07583737613503
    },
    {
        "id": 88,
        "x": 75.32976615447127,
        "y": 81.77229931937882
    },
    {
        "id": 89,
        "x": 47.49566801340064,
        "y": 54.91227080703116
    },
    {
        "id": 90,
        "x": 54.987138219013886,
        "y": 46.61758500157897
    },
    {
        "id": 91,
        "x": 64.87389046245613,
        "y": 98.77753470104587
    },
    {
        "id": 92,
        "x": 79.36107599655784,
        "y": 34.84480896862892
    },
    {
        "id": 93,
        "x": 29.731999245376063,
        "y": 35.50792111941481
    },
    {
        "id": 94,
        "x": 73.26268765431583,
        "y": 29.062410213589395
    },
    {
        "id": 95,
        "x": 2.2399300856172033,
        "y": 11.955896824463208
    },
    {
        "id": 96,
        "x": 12.481415496450277,
        "y": 68.45156766154562
    },
    {
        "id": 97,
        "x": 40.49221088191124,
        "y": 77.22479166240868
    },
    {
        "id": 98,
        "x": 33.59740917090291,
        "y": 76.02633615328543
    },
    {
        "id": 99,
        "x": 41.347646595959596,
        "y": 29.82339743181455
    }
]
export default voronoidata;